// import { parseJwt } from '../../app/views/login/Login';
import { BASE_URL } from '../../config/environmentConfig';
import * as auth from '../../app/redux/AuthRedux';
import { toaster } from 'rsuite';
import toastMessage from '../../app/components/ToastMessage';
import eventEmitter from '../../app/utils/loginModalState';
import {
	APPLICATION_VIEW_BASE_VIEW,
	APPLICATION_VIEW_STEPS,
} from '../../app/components/application-view/ApplicationViewAsideMenu';
import { UserModel } from '../../app/models/UserModel';
// import { history } from '../../index';
// import toastMessage, { toastRefreshMessage } from '../../app/components/ToastMessage';
//
// export let refreshToastKeys = [];

export default function setupAxios(axios: any, store: any): void {
	axios.defaults.headers.Accept = 'application/json';
	// axios.defaults.withCredentials = true;
	axios.interceptors.request.use(
		(config: any) => {
			const {
				auth: { idToken }
			} = store.getState();

			if (idToken) {
				config.headers.Authorization = `Bearer ${idToken}`;
				// config.headers.idToken = idToken;
			} else {
				const localToken = localStorage.getItem('idToken');
				if (localToken) {
					config.headers.Authorization = `Bearer ${localToken}`;
				}
			}

			return config;
		},
		(err: any) => {
			return Promise.reject(err);
		}
	);
	axios.interceptors.response.use(
		function(response) {
			return response;
		},
		async function(error) {
			const originalRequest = error.config;

			const {
				auth: { userData }
			} = store.getState();

			// Prevent infinite loop and multiple refresh attempts
			if (error?.response?.status === 401 &&
				!originalRequest._retry &&
				!originalRequest.url?.includes('/Tokens/access-tokens/refresh')) {

				// Set a global flag to prevent multiple refresh attempts
				if (axios.isRefreshing) {
					// Wait for the refresh to complete
					try {
						// Wait for the refreshing process to complete
						await new Promise(resolve => {
							const checkRefreshing = (): void => {
								if (!axios.isRefreshing) {
									resolve(true);
								} else {
									setTimeout(checkRefreshing, 100);
								}
							};
							checkRefreshing();
						});

						// Get the new token from store
						const { auth: { idToken }} = store.getState();
						if (idToken) {
							originalRequest.headers.Authorization = `Bearer ${idToken}`;
							return axios(originalRequest);
						}
					} catch (err) {
						return Promise.reject(error);
					}
				}

				// Set the flag to indicate we're refreshing
				axios.isRefreshing = true;
				originalRequest._retry = true;

				try {
					console.log('Attempting to refresh token with fetch...');
					// Use fetch instead of axios for the refresh token request
					const response = await fetch(`${BASE_URL.IDENTITY}/Tokens/access-tokens/refresh`, {
						method: 'POST',
						credentials: 'include', // This ensures cookies are sent
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({})
					});

					if (!response.ok) {
						store.dispatch(auth.actions.logout());
						throw new Error(`Refresh token failed with status: ${response.status}`);
					}

					const data = await response.json();

					// Update tokens in store while preserving user data
					store.dispatch(auth.actions.login({
						accessToken: data.accessToken,
						idToken: data.id,
						userData
					}));

					// Reset the refreshing flag
					axios.isRefreshing = false;

					// Update Authorization header for the original request
					originalRequest.headers.Authorization = `Bearer ${data.id}`;

					// Retry original request with new token
					return axios(originalRequest);
				} catch (refreshError) {
					console.log('Token refresh failed:', refreshError);
					// Reset the refreshing flag
					axios.isRefreshing = false;

					// Only logout if the refresh token is invalid or expired
					if (refreshError?.response?.status === 401) {
						store.dispatch(auth.actions.logout());
						eventEmitter.emit('openModal');
					}
					return Promise.reject(error);
				}
			}

			// Handle other error cases
			switch (error?.response?.status) {
				case 403: {
					// Keep existing 403 handling
					if (window.location.pathname?.includes('not-found')) {
						// No redirection occurs if the path includes 'not-found'
					} else if (window.location.pathname?.includes('dashboard')) {
						window.location.href = '/not-found';
					} else {
						window.location.href = '/dashboard';
					}
					break;
				}
				case 404: {
					const isPaymentInstrumentRequest = error?.request?.responseURL?.includes('paymentInstruments') &&
						error?.request?.responseURL?.includes('token');
					const isApplicantViewRequest = window.location.pathname?.includes(`/${APPLICATION_VIEW_BASE_VIEW}/${APPLICATION_VIEW_STEPS.SUMMARY}`);

					if (!isPaymentInstrumentRequest && !isApplicantViewRequest) {
						// history.push('/not-found');
						// window.location.href = '/not-found';
						toaster.push(toastMessage({
							text: 'Something went wrong',
							type: 'error'
						}), { placement: 'topEnd' });
					}
					break;
				}
				case 500: {
					// history.push('/error');
					if (error?.response?.config?.url === `${BASE_URL.IDENTITY}/identity/sign-out`) {
						store.dispatch(auth.actions.logout());
						window.location.href = '/auth/login';
					} else {
						// window.location.href = '/error';
					}
					break;
				}
				default: {
					// sendSentryMessage({ name: `Error`, context: error });
					// generalErrorHandler({ e: error });
				}
			}

			return Promise.reject(error);
		}
	);
}
